import React from 'react';
import { CustomPagination } from '../CustomPagination';

export const DamageClaimsCommentsPagination = ({ queryCount, paginate, currentPage }) => {
  const pages = Math.ceil(queryCount / 5);

  return <CustomPagination currentPage={currentPage} pages={pages} paginate={paginate} />;
};
